module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'w0kc5mau',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
